import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { api } from "../api";

import DepartmentSidebar from "./DepartmentSidebar.jsx";
import JybekWidget from "./JybekWidget.jsx";
function isPathActive(to, pathname) {
  if (to === "/") return pathname === "/";
  return pathname === to || pathname.startsWith(to + "/");
}

export default function Layout({ user, onLogout, children, sidebarOpen, onCloseSidebar }) {
  const isAdmin = user.role === "admin";
  const location = useLocation();

  const items = isAdmin
    ? [
        { to: "/", label: "Dashboard", exact: true },
        { to: "/admin/clients", label: "Clients" },
        { to: "/admin/caregivers", label: "Caregivers" },
        { to: "/admin/scheduling", label: "Scheduling" },
        { to: "/admin/accounting", label: "Accounting" },
        { to: "/admin/reports", label: "Reports" },
        {
          label: "HR Management",
          group: true,
          // Flat sub-items directly in the sidebar, replacing the old
          // single link to the tile-based HRHome.jsx landing page. Not
          // every HR concept has its own dedicated page (Recruitment now
          // lives inside the Employees hub as a tab; Documents is
          // per-employee, not a standalone list) — "More HR Modules"
          // keeps the tile page reachable for Inventory, Staff Loans,
          // Disciplinary Cases, and Tasks, which don't have a flat link
          // of their own here.
          children: [
            { to: "/admin/employees", label: "Employees" },
            { to: "/admin/hr/attendance", label: "Attendance" },
            { to: "/admin/hr/leave_requests", label: "Leave Requests" },
            { to: "/admin/hr/payroll", label: "Payroll" },
            { to: "/admin/hr/performance_reviews", label: "Performance" },
            { to: "/admin", label: "Training (LMS)", exact: true },
            { to: "/admin/dashboard", label: "Compliance" },
            { to: "/admin/hr/assets", label: "Assets" },
            { to: "/admin/hr", label: "More HR Modules", exact: true },
          ],
        },
        { to: "/admin/users", label: "Users" },
        { to: "/admin/data-migration", label: "Data Migration" },
      ]
    : [
        { to: "/", label: "My Dashboard", exact: true },
        { to: "/portal/schedule", label: "My Schedule" },
        { to: "/portal/compliance", label: "My Compliance" },
        { to: "/portal/training", label: "My Training" },
      ];

  // Auto-expand any group that contains the current route, so landing
  // directly on e.g. /admin/hr/payroll (a bookmark, a link from
  // elsewhere) doesn't leave the sidebar looking collapsed/unrelated to
  // where you actually are.
  const initialOpen = {};
  items.forEach((item) => {
    if (item.group) {
      initialOpen[item.label] = item.children.some((c) => isPathActive(c.to, location.pathname));
    }
  });
  const [openGroups, setOpenGroups] = useState(initialOpen);

  const toggleGroup = (label) => {
    setOpenGroups((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  const handleLogout = async () => {
    await api.logout();
    onLogout(null);
  };

  return (
    <div className="flex min-h-screen">
      <DepartmentSidebar user={user} onLogout={onLogout} isOpen={sidebarOpen} onNavigate={onCloseSidebar} />
      {sidebarOpen && <div className="sidebar-backdrop" onClick={onCloseSidebar} />}
      <main className="flex-1 bg-pink-50 p-6 overflow-auto">{children}</main>
      <JybekWidget />
    </div>
  );
}
